import { Link } from 'gatsby';
import styled from 'styled-components';

const ButtonLink = styled(Link)`
	display: inline-block;
	padding: ${(p) => (p.size === 'large' ? '0.5rem 2rem' : '0 2rem')};
	border: none;
	border-radius: 0.5rem;
	font-weight: 700;
	font-size: ${(p) => (p.size === 'large' ? '1.25rem' : '1rem')};
	line-height: 2.5rem;
	letter-spacing: 0.2em;
	text-decoration: none;
	color: #fff !important;
	background-color: ${(p) => {
		if (p.bg === 'green') {
			return p.theme.color.green;
		} else if (p.bg === 'teal') {
			return p.theme.color.teal;
		} else if (p.bg === 'purple') {
			return p.theme.color.purple;
		} else if (p.bg === 'dark') {
			return p.theme.color.dark;
		} else {
			return p.theme.color.red;
		}
	}};
	transition: box-shadow 0.3s;
	&:hover {
		box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
	}
`;

export default ButtonLink;
